<!-- 第一次登录时必读书本 -->
<template>
  <div class="required">
    <div class="required_left">
    </div>
    <div class="required_center">
      <div class="required_top">
        <el-button type="info" disabled v-if="num > 0" class="disabled">{{msg}}</el-button>
        <el-button @click="nextPage()" type="primary" v-if="num < 1" class="normality">{{msg}}</el-button>
        <el-button type="primary" class="close" @click="close">返回登录界面</el-button>
      </div>
      <div class="required_content" id="required_content">
        <img :src= src alt="">
      </div>
    </div>
    <div class="required_right">
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
import * as req2 from '@/utils/requestBook'
export default {
  data () {
    return {
      index: 0,
      pageList: [],
      time: 5000,
      num: 5,
      addTime: 5,
      // msg: '下一页',
      readPage: []
    }
  },
  computed: {
    stationId: function () {
      return this.$route.query.stationId
    },
    msg: function () {
      if (this.index === this.pageList.length - 1 && this.num === 0) {
        return '已读完, 点击进入主页'
      }
      if (this.num > 0) {
        return this.num + '秒后可点击'
      }
      return '下一页'
    },
    src: function () {
      let index = this.index
      if (this.pageList.length < 1) {
        return ''
      }
      let requiredUrl = this.global.loginBook
      let str = requiredUrl + this.stationId + '/' + this.pageList[index].path
      return str
    }
  },
  mounted () {
  },
  methods: {
    nextPage () {
      document.getElementById('required_content').scrollTop = 0
      if (this.index === this.pageList.length - 1) {
        this.enterUpdate()
        this.stopCountDown()
        this.int = 0
        this.$router.push({path: '/index/menuIndex'})
        return
      }
      this.index++
      if (this.readPage.indexOf(this.index) < 0) {
        this.countDown()
      }
    },
    enterUpdate () {
      let msg = {}
      msg.id = this.global.user_info.id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.enterFn
      sendData.vm = this
      req.Post('user/restEnter', sendData)
    },
    // 倒计时
    countDown () {
      this.stopCountDown()
      this.num = 5
      let _this = this
      this.int = setInterval(function () {
        _this.clock()
      }, 1000)
    },
    clock () {
      if (this.num > 0) {
        this.num--
        // return
      }
      if (this.num === 0) {
        this.stopCountDown()
        // 如果读完这本书发送读完的消息,修改用户是否为第一次登陆的状态
        if (this.index === this.pageList.length - 1) {
          // 发送消息修改用户是否为第一次登陆的状态
          // 保存成功后调用close
          let msg = {}
          msg.id = this.global.user_info.id
          let data = {}
          // 首次阅读完
          // data.is_enter = false
          msg.data = data
          let sendData = {}
          sendData.data = msg
          sendData.fn = this.recordFn
          sendData.vm = this
          req.Post('user/eidt_User', sendData)
        }
      }
    },
    recordFn (data) {
      if (data === null) {
        alert('服务器未连接')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    stopCountDown () {
      clearInterval(this.int)
      // console.info('stop time', this.int)
      this.int = 0
      this.num = 0
    },
    // 关闭, 返回登录界面
    close () {
      window.location.href = window.$global.loginURL
    },
    // 根据职位id获取书本内容
    getRequired () {
      let msg = {}
      msg.station_id = this.stationId
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getRequiredfn
      sendData.vm = this
      req2.Post('fileMenuData/get_loginBook', sendData)
    },
    getRequiredfn (data) {
      if (data === null) {
        alert('服务器未连接')
        window.location.href = window.$global.loginURL
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        this.$router.push({path: '/index/menuIndex'})
        return
      }
      let page = data.list
      let list = page.page_list
      this.pageList = list
      if (list.length > 0) {
        this.countDown()
      }
    }
  },
  created () {
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getRequired()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    this.stopCountDown()
    next()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nextPage{
  width: 100px;
  height: 50px;
  background: #b4b4b4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 255, 255);
}
.clickable {
  background: rgb(64,158,255);
}
.required {
  width: 100%;
  height: 100%;
  display: flex;
  background: #cdcdcd;
}
.required_center{
  width: 50%;
  height: 100%;
}
.required_content{
  height: 92%;
  overflow-y: auto;
}
.required_top{
  height: 8%;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: white;
  position: relative;
  top: 0;
}
.required_content > img {
  width: 100%;
}
.required_left {
  width: 25%;
  height: 100%;
}
.required_right {
  width: 25%;
  height: 100%;
}
.disabled{
  margin: auto;
}
.normality{
  margin: auto;
}
.close{
  position: absolute;
  right: 0;
}
.previous{
  position: absolute;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/required.vue